import React, { Component } from "react";

import "./ErrorBoundary.scss";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  hardReload = () => {
    window.location.reload(true);
  };

  removeAllCookies = () => {
    let cookies = document.cookie.split("; ");
    for (let c = 0; c < cookies.length; c++) {
      let d = window.location.hostname.split(".");
      while (d.length > 0) {
        let cookieBase =
          encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
          "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
          d.join(".") +
          " ;path=";
        let p = window.location.pathname.split("/");
        document.cookie = cookieBase + "/";
        while (p.length > 0) {
          document.cookie = cookieBase + p.join("/");
          p.pop();
        }
        d.shift();
      }
    }
  };

  clearLocalData = () => {
    this.removeAllCookies();
    window.localStorage.clear();
    this.hardReload();
  };

  render() {
    if (this.state.errorInfo) {
      return (
        <div className="sdd-general-error-container">
          <h2>
            Sorry, an unexpected error occured. Please contact administrators or
            help desk if the issue persists.{" "}
          </h2>
          <div className="self-help">
            <h2>Self-help</h2>
            <ul>
              <li>
                Press the <strong>Clear local data</strong> button below to
                clear local data, such as cookies and local storage.
              </li>
              <li>
                <strong>Disclaimer: </strong> Some cookies need manual deletion.
              </li>
            </ul>
            <div>
              <button className="btn btn-danger" onClick={this.clearLocalData}>
                Clear local data
              </button>
            </div>
          </div>
          <div className="self-help">
            <h2>Reporting the error to help desk</h2>
            <p>
              To help improve this software, please, click on Details below,
              copy the expanded text and submit it along with your description
              of how the error happened. Thank you.
            </p>
            <details style={{ whiteSpace: "pre-wrap" }}>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
